export default "__VITE_ASSET__CXhqswG9__";